interface Item {
  label: string;
  value: string;
}

export const dicts: Record<string, Item[]> = {
  goals: [
    { label: 'Серьезные отношения', value: 'serious' },
    { label: 'Открытые отношения', value: 'open' },
    { label: 'Дружба', value: 'friendship' },
  ],
  alcoholViews: [
    { label: 'Не пьёт', value: 'none' },
    { label: 'Редко', value: 'rarely' },
    { label: 'Пьёт', value: 'often' },
  ],
  smokingViews: [
    { label: 'Не курит', value: 'none' },
    { label: 'Курит за компанию', value: 'social' },
    { label: 'Бросает', value: 'quitting' },
    { label: 'Курит', value: 'smokes' },
    { label: 'Вейпит', value: 'vapes' },
  ],
  hasChildren: [
    { label: 'Есть дети', value: 'has_children' },
    { label: 'Нет детей, но планирует когда-нибудь', value: 'plans_children' },
    { label: 'Нет детей', value: 'no_children' },
    { label: 'Не планирует', value: 'no_plans' },
  ],
  zodiac: [
    { label: 'Овен', value: 'aries' },
    { label: 'Телец', value: 'taurus' },
    { label: 'Близнецы', value: 'gemini' },
    { label: 'Рак', value: 'cancer' },
    { label: 'Лев', value: 'leo' },
    { label: 'Дева', value: 'virgo' },
    { label: 'Весы', value: 'libra' },
    { label: 'Скорпион', value: 'scorpio' },
    { label: 'Стрелец', value: 'sagittarius' },
    { label: 'Козерог', value: 'capricorn' },
    { label: 'Водолей', value: 'aquarius' },
    { label: 'Рыбы', value: 'pisces' },
  ],
};
